import React from "react";
import { X, TriangleAlertIcon } from "lucide-react";

const WarningModal = ({
  open,
  title = "Warning",
  message,
  subMessage,
  confirmText = "Confirm",
  cancelText = "Later",
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10">
      <div className="bg-yellow-50 border border-yellow-300 rounded-xl shadow-lg w-[90%] max-w-md p-6 animate-scaleIn">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold text-yellow-800 flex items-center gap-2">
            <TriangleAlertIcon size={32} className="text-yellow-500" />
            {title}
          </h3>
          <button
            onClick={onCancel}
            className="text-yellow-700 hover:text-yellow-900"
          >
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        {message && (
          <p className="text-sm text-yellow-800 mb-1">{message}</p>
        )}
        {subMessage && (
          <p className="text-sm text-yellow-800 mb-4">{subMessage}</p>
        )}

        {/* Actions */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-3 py-2 text-sm border border-yellow-400 text-yellow-800 rounded-md hover:bg-yellow-100"
          >
            {cancelText}
          </button>

          <button
            onClick={onConfirm}
            className="px-3 py-2 text-sm bg-yellow-600 hover:bg-yellow-700 text-white rounded-md"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;